import { PageableResponse } from "../PageableResponse";
import { RestClient } from "../RestClient";

// 得意先元帳データ検索リクエスト
export type B030070Request = {
  urikakeYm: string;
  torihikiKbn: string;
  urikakeCd: string;
  urikakeshitenCd: string;
} & Partial<{
  page: number;
  sort: string[];
  size: number;
}>;

export type B030070FindResponse = {
  shainCd: string;
  shainNm: string;
  telNo: string;
  faxNo: string;
  shimeD: string;
  kaishuyoteiD: string;
  kaishuKbn: string;
  tokuibunNm1: string;
  tokuibunNm2: string;
  tokuibunNm3: string;
  tokuibunNm4: string;
  tokuibunNm5: string;
  urikakeCd: string;
  urikakeshitenCd: string;
  urikakeYm: string;
  zenzanKin: string;
  konkainyuKin: string;
  konkaiuriKin: string;
  henpinnebikiKin: string;
  sotozeiKin: string;
  uchizeiKin: string;
  urikakezanKin: string;
  genkinnyuKin: string;
  furikominyuKin: string;
  tegatanyuKin: string;
  kogitenyuKin: string;
  sosainyuKin: string;
  nebikinyuKin: string;
  tesuryoKin: string;
  sonotanyuKin: string;
  headerUriKin: string;
  henpinKin: string;
  nebikiKin: string;
  sonotauriKin: string;
  denpyoYmd: string;
  denpyoNo: string;
  denpyogyoNo: string;
  torihikiKbn: string;
  chumonNo: string;
  chohaKbn: string;
  uchiwakeNm: string;
  shohinCd: string;
  shohinNm: string;
  urisu: string;
  uritanka: string;
  uriKin: string;
  zeiKin: string;
  nyuKin: string;
  meisaibiko: string;
  seikyuNmr: string;
  tokuiNmr: string;
};

// 得意先元帳データ検索処理
export const B030070Find = (props: B030070Request) => {
  return RestClient.get<PageableResponse<B030070FindResponse>>("b030070/find", {
    params: props,
  });
};
